import api from '../../../services/api';

/**
 * Fetch all versions for a specific section
 */
export const fetchSectionVersions = async (rfpId, sectionId) => {
    return api.get(`/rfp/${rfpId}/sections/${sectionId}/versions`);
};

/**
 * Fetch global document versions
 */
export const fetchGlobalVersions = async (rfpId, params = {}) => {
    return api.get(`/rfp/${rfpId}/versions`, { params });
};

/**
 * Fetch a specific version by its version number
 */
export const fetchVersionDetail = async (rfpId, sectionId, verNum) => {
    return api.get(`/rfp/${rfpId}/sections/${sectionId}/versions/${verNum}`);
};

/**
 * Update the label for a specific version
 */
export const updateVersionLabel = async (rfpId, sectionId, verNum, label) => {
    return api.patch(`/rfp/${rfpId}/sections/${sectionId}/versions/${verNum}/label`, { label });
};

/**
 * Revert to a specific version
 */
export const revertToVersion = async (rfpId, sectionId, verNum, reason) => {
    return api.post(`/rfp/${rfpId}/sections/${sectionId}/versions/revert`, { target_version: verNum, reason });
};

/**
 * Compare two versions of a section
 */
export const compareVersions = async (rfpId, sectionId, v1, v2) => {
    return api.get(`/rfp/${rfpId}/sections/${sectionId}/versions/compare`, {
        params: { v1, v2 }
    });
};

/**
 * Approve a specific version for a section (Team Lead or Admin only)
 * POST /rfp/{rfp_id}/sections/{section_id}/versions/{version_number}/approve
 */
export const approveSectionVersion = async (rfpId, sectionId, versionNumber) => {
    return api.post(`/rfp/${rfpId}/sections/${sectionId}/versions/${versionNumber}/approve`);
};
